import type { Filter, FilterDataOption } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import type { TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { getTranslationServer } from '@/app/components/translations/createTranslationDictionary.ts';
import { SortValues } from '@/app/common/memsearch/types.ts';

type CreateSortFiltersProps = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};

export const createSortFilters = ({ searchParams, translationDictionary }: CreateSortFiltersProps): Filter[] => {
  const sortOptionValues = [
    {
      value: SortValues.Recommended,
      label: getTranslationServer('vacation.oss.components.searchresults.sort.recommended', translationDictionary),
    },
    {
      value: SortValues.PriceAsc,
      label: getTranslationServer('vacation.oss.components.searchresults.sort.price_asc', translationDictionary),
    },
    {
      value: SortValues.PriceDesc,
      label: getTranslationServer('vacation.oss.components.searchresults.sort.price_desc', translationDictionary),
    },
    {
      value: SortValues.CategoryDesc,
      label: getTranslationServer('vacation.oss.components.searchresults.sort.category_desc', translationDictionary),
    },
    {
      value: SortValues.CategoryAsc,
      label: getTranslationServer('vacation.oss.components.searchresults.sort.category_asc', translationDictionary),
    },
    {
      value: SortValues.TopReviewed,
      label: getTranslationServer('vacation.oss.components.searchresults.sort.top_reviewed', translationDictionary),
    },
  ];

  const selectedValue = searchParams[URLParameters.SORT] || SortValues.Recommended;
  const validSelectedValue =
    Object.values(SortValues).includes(selectedValue as SortValues) &&
    sortOptionValues.find((option) => option.value === selectedValue)
      ? selectedValue
      : SortValues.Recommended;

  const options: FilterDataOption[] = sortOptionValues.map((option) => ({
    label: option.label,
    selected: option.value === validSelectedValue,
    value: option.value,
    counter: undefined,
    isDefault: option.value === SortValues.Recommended,
  }));

  const sortFilter: Filter = {
    name: FILTER_NAME.SORT,
    type: FILTER_TYPE.RADIO,
    data: {
      options,
      defaultValue: SortValues.Recommended,
    },
  };

  return [sortFilter];
};
